import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import styled, { Theme } from '../styled-components';
import _ from 'lodash';

import AppContext from '../services/Context';
import I18n from '../i18n';

import ApiResponseDisplayer from '../components/ApiResponseDisplayer';
import Modal from '../components/Modal';
import { Button, Col, Checkbox } from 'antd';
import NotificationComponent from '../helpers/_showNotifications'

import { Product as ProductInterface } from '../interfaces/IProduct';
import ProductService from '@services/Product';
import ProductCheckmanService from '@services/cm/Product';

import { Alert as AlertInterface } from '@interfaces/cm/Alert';
import Row from 'antd/lib/grid/row';
import AlertService from '@services/cm/Alert';
import Page from '../components/Page';
import ProductServiceCM from '@services/cm/Product';

const _productsService: ProductServiceCM = new ProductServiceCM();
const _alertsService: AlertService = new AlertService();
const _productCheckmanService: ProductCheckmanService = new ProductCheckmanService();

type PropType = {};
type StateType = {
    isLoading: boolean;
    isLoadingAlerts: boolean;
    showFormModal: boolean;
    productsData: ProductInterface[];
    curProduct?: ProductInterface;
    wantedProduct?: ProductInterface;
    alertsData: AlertInterface[];
    curAlertsSelected: string[];
    curItems: any;
    showDraggableItems: boolean;
    curAlertsNotSelected: string[];
    filteredTableData: ProductInterface[];
    editItem?: ProductInterface;
    serverResponse: any;
    search: string;
    savingBound: boolean;
    savedBound: boolean;
    changingProduct: boolean;
};

const grid = 8;

class Products extends React.Component<PropType, StateType> {

    constructor(props: any) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this);
    }

    private idUnit: string = '';

    state = {
        isLoading: true,
        isLoadingAlerts: false,
        showFormModal: false,
        productsData: [],
        curProduct: undefined,
        wantedProduct: undefined,
        alertsData: [],
        curAlertsSelected: [],
        curItems: [],
        showDraggableItems: false,
        curAlertsNotSelected: [],
        filteredTableData: [],
        search: '',
        editItem: {
            id: '',
            name: '',
            code: '',
            photo: '',
        },
        serverResponse: undefined,
        savingBound: false,
        savedBound: false,
        changingProduct: false,
    };

    setUnit(unitId: string) {
        //console.log('set unit: ', unitId);
        this.idUnit = unitId;
    }

    componentDidMount() {
        this.getProducts(true, true);
    }

    toggleFormModal = () =>
        this.setState({
            showFormModal: !this.state.showFormModal,
            serverResponse: undefined,
            editItem: {
                id: '',
                name: '',
                code: '',
                photo: '',
            },
        });

    getProducts = async (reset: boolean, showLoading: boolean) => {
        // this.setState({ isLoading: true, showFormModal: false });
        this.setState({ showFormModal: false });

        try {
            const data: any = await _productsService.listAll();
            const dataTableCreate: any = [];
            data.map((item: any) => {
                dataTableCreate.push({
                    id: item.id,
                    code: item.code,
                    name: item.name,
                    photo: item.photo,
                    created: item.createdAt,
                    action: true
                })
            })
            console.log(data);
            this.setState({
                isLoading: false,
                productsData: data,
            });
        } catch (error) {
            console.warn(error);
            this.setState({
                isLoading: false,
            });
        }
    };

    getAlerts = async () => {
        this.setState({ isLoadingAlerts: true });
        
        try {
            
            const data: any = await _alertsService.listAll(this.idUnit);
            console.log("get alerts: ", data);
            //console.log("Alerts: ", data);
            this.setState({
                isLoadingAlerts: false,
                alertsData: data,
            });
        } catch (error) {
            console.warn(error);
            this.setState({
                isLoadingAlerts: false,
            });
        }
    };

    openEditModal = (editItem: ProductInterface) => {
        this.setState({ editItem, showFormModal: true });
    };

    onSubmit = async (input: ProductInterface, actions: { setSubmitting: Function }) => {
        const { productsData, editItem } = this.state;

        try {

            let nextTableData: ProductInterface[] = [];

            if (!!input.id) {

                if (editItem.photo === input.photoData) {
                    input.photoData = undefined;
                }

                const response = await _productsService.updateById(input.id, input);
                const targetIndex = findIndex(
                    productsData,
                    (item: ProductInterface) => item.id === response.id,
                );
                nextTableData = productsData;
                if (nextTableData[targetIndex]) {
                    nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
                }
            } else {
                const response = await _productsService.create(input);
                nextTableData = [response, ...productsData];
            }
            const dataTableCreate: any = [];
            nextTableData.map((item: any) => {
                dataTableCreate.push({
                    id: item.id,
                    code: item.code,
                    name: item.name,
                    photo: item.photo,
                    created: item.createdAt,
                    action: true
                })
            })
            actions.setSubmitting(false);
            this.setState({ isLoading: false, showFormModal: false, productsData: nextTableData });
        } catch (error) {
            NotificationComponent.Notify('error', 'Erro ao cadastrar', error);
        } finally {
            actions.setSubmitting(false);
        }
    };

    deleteProduct = async (id: string) => {
        try {
            // TODO: confirmar com Modal

            const { productsData } = this.state;
            const nextTableData = productsData.filter((item: ProductInterface) => item.id !== id);
            this.setState({
                isLoading: false,
                productsData: nextTableData,
            });
            await _productsService.deleteById(id);
        } catch (e) {
            // TODO: mostrar erro com Modal
            console.error(e);
        }
    };

    searchData = async (event: any) => {

        let searchTableData: ProductInterface[] = [];
        const SearchValue = event === '' ? false : event.target.find.value;
        this.setState({
            search: SearchValue,
            isLoading: true,
        })

        if (!SearchValue) {
            this.getProducts(true, false);
        }
        try {
            _.some(this.state.productsData, (o: any) => {
                console.log(_.includes(o.name, SearchValue))
                if (_.includes(o.name, SearchValue) || _.includes(o.code, SearchValue)) {
                    searchTableData.push(o)
                }
            })
            this.setState({
                isLoading: false,
                productsData: searchTableData
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    onProductItemClicked = async (product: ProductInterface, curProduct: ProductInterface) => {
        //console.log("Product: ", product);

        if (curProduct !== undefined) {
            if (product.id === curProduct.id) {
                return;
            }
        }

        this.setState({ wantedProduct: product });

        if (curProduct === undefined) {
            this.loadProductAlerts(product);
        } else {
            this.setState({ changingProduct: true });
        }
    }

    confirmProductChange = async (product: ProductInterface) => {
        this.setState({ changingProduct: false });
        this.loadProductAlerts(product);
    }

    cancelProductChange = async () => {
        this.setState({ changingProduct: false });
    }

    loadProductAlerts = async (product: ProductInterface) => {
        this.setState({ curProduct: product, curItems: [] });

        this.getAlerts();
    }

    renderProductItem(product: ProductInterface, index: number, curProduct: ProductInterface) {
        // console.log("Product [" + index + "]: ", product);

        let classNameToProduct = "goepik-product-item";

        if (curProduct != undefined && curProduct.id != undefined) {
            if (product.id == curProduct.id) {
                classNameToProduct += " " + "goepik-product-active";
            }
        }

        return (
            <GoEpikClickableItem key={index}>
                <Row className={classNameToProduct} onClick={() => this.onProductItemClicked(product, curProduct)}>
                    <Col sm={24} md={24} xl={24}>
                        <h4>{product.code}</h4>
                    </Col>
                </Row>
            </GoEpikClickableItem>
        )
    }

    renderAlertList(alerts: AlertInterface[], curProduct: ProductInterface) {
        //console.log("Alerts to show: ", alerts);

        let alertsCheckboxData: string[] = [];

        alerts.map((alert: AlertInterface) => {
            alertsCheckboxData.push(alert.name);
        })

        //console.log("Alert to Checkbox: ", alertsCheckboxData);

        let alertsAlreadySelected: AlertInterface[] = [];
        let alertsAlreadySelectedCheckboxData: string[] = [];

        let alertsIdFounded: string[] = [];
        if (curProduct !== undefined) {
            if (curProduct.cm !== undefined) {
                //console.log("CM: ", curProduct.cm);
                if (curProduct.cm.alerts.length > 0) {
                    alertsIdFounded = curProduct.cm.alerts;
                    alertsAlreadySelected = this.getAlertsByIds(alertsIdFounded);
                }
            } else {
                //console.log("This product don't have alerts yet");
            }
        }


        if (alertsAlreadySelected.length > 0) {
            alertsAlreadySelected.map((alert: AlertInterface) => {
                if(alert != undefined)
                    alertsAlreadySelectedCheckboxData.push(alert.id);
            })

            //console.log("Alerts Selected: ", alertsAlreadySelected);
            //console.log("Alerts Selected to Checkbox: ", alertsAlreadySelectedCheckboxData);
        }

        if (alertsCheckboxData.length > 0) {
            return (
                <GoEpikVerticalCheckbox>
                    <Checkbox.Group onChange={this.onAlertsSelectedChanged} defaultValue={alertsAlreadySelectedCheckboxData}>
                        <Row>
                            {
                                alerts.map((alert: AlertInterface, i: number) => {
                                    return (                                                                              
                                        <Col key={i}><Checkbox value={alert.id}>{alert.name}</Checkbox></Col>
                                    )
                                })
                            }
                        </Row>
                    </Checkbox.Group>
                </GoEpikVerticalCheckbox>
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    getAlertsByIds = (ids: string[]) => {
        let alertsToReturn: AlertInterface[] = [];

        ids.map((id: string) => {
            alertsToReturn.push(this.state.alertsData.filter((item: AlertInterface) => item.id == id)[0]);
        })

        return alertsToReturn;
    }

    onAlertsSelectedChanged = async (checkedValues: any) => {
        this.setState({ curAlertsSelected: checkedValues, showDraggableItems: false })

        if (this.state.alertsData.length > 0) {
            let alertsCheckboxData: string[] = [];

            this.state.alertsData.map((alert: AlertInterface) => {
                alertsCheckboxData.push(alert.id);
            })

            let difference: string[] = [];
            difference = this.arr_diff(alertsCheckboxData, checkedValues);

            //console.log("not selected: ", difference);
            this.setState({ curAlertsNotSelected: difference });

            var itemsToDrag: any = [];
            //console.log("alerts id to load: ", this.state.curProduct.cm.alerts);

            var alertsToLoadIds: string[] = [];
            this.state.curProduct.cm.alerts.map((alert: AlertInterface) => {
                if (this.state.curProduct.cm.alerts.indexOf(alert.id) > -1) {
                    alertsToLoadIds.push(alert.id);
                }
            });

            var alertsToLoad: AlertInterface[] = this.getAlertsByIds(alertsToLoadIds);
            alertsToLoad.map((alert: AlertInterface, i: number) => {
                itemsToDrag.push({
                    id: alert.id,
                    content: alert.name
                });

                alertsToLoadIds.push(alert.id);
            })


            var alertsToAddToOrderIds: string[] = this.arr_diff(this.state.curAlertsSelected, alertsToLoadIds);
            //console.log("dif result: ", alertsToAddToOrderIds);
            //console.log(alertsToAddToOrderIds);

            var alertsToAddToOrder: any[] = this.getAlertsByIds(alertsToAddToOrderIds);
            alertsToAddToOrder.map((alert: AlertInterface) => {
                itemsToDrag.push({
                    id: alert.id,
                    content: alert.name
                })
            });

            this.setState({ curItems: itemsToDrag })
            //console.log('checked = ', this.state.curItems);
        }

        this.setState({ showDraggableItems: true })
    }

    arr_diff(a1: any, a2: any) {

        var a = [], diff = [];

        for (var i = 0; i < a1.length; i++) {
            a[a1[i]] = true;
        }

        for (var i = 0; i < a2.length; i++) {
            if (a[a2[i]]) {
                delete a[a2[i]];
            } else {
                a[a2[i]] = true;
            }
        }

        for (var k in a) {
            diff.push(k);
        }

        return diff;
    }

    onSaveClicked(itemsToSave: string[], itemsToDelete: string[], curProduct: ProductInterface) {
        this.saveItems(itemsToSave, itemsToDelete, curProduct);
    }

    saveItems = async (itemsToAdd: string[], itemToDelete: string[], product: ProductInterface) => {
        this.setState({ savingBound: true });

        try {
            //console.log("item to add: ", itemsToAdd);

            //ADDING
            for (let index = 0; index < itemsToAdd.length; index++) {
                if (product.cm !== undefined) {
                    if (product.cm.alerts.length > 0) {
                        // if (product.cm.alerts.find((alert: AlertInterface) => alert.id === itemsToAdd[index]) !== undefined) {
                        if (product.cm.alerts.indexOf(itemsToAdd[index]) > -1) {
                            //console.log("already had this item: ", itemsToAdd[index]);
                        } else {
                            //console.log("saving: ", itemsToAdd[index]);
                            const response = await _productCheckmanService.alertAdd(product.id, itemsToAdd[index]);
                            //console.log("Save Response: ", response);
                        }
                    } else if (product.cm.alerts.length === 0) {
                        //console.log("saving: ", itemsToAdd[index]);
                        const response = await _productCheckmanService.alertAdd(product.id, itemsToAdd[index]);
                        //console.log("Save Response: ", response);
                    }
                } else {
                    console.log("saving pure: ", itemsToAdd[index]);
                    const response = await _productCheckmanService.alertAdd(product.id, itemsToAdd[index]);
                    console.log("Save Pure Response: ", response);
                }
            }

            //DELETING
            //console.log("item to delete: ", itemToDelete);
            for (let index = 0; index < itemToDelete.length; index++) {
                if (product.cm !== undefined) {
                    if (product.cm.alerts.length > 0) {
                        if (product.cm.alerts.indexOf(itemToDelete[index]) > -1) {
                            //console.log("deleting: ", itemToDelete[index]);
                            const response = await _productCheckmanService.alertDel(product.id, itemToDelete[index]);
                            //console.log("delete Response: ", response);
                        } else {
                            //console.log("dont have this item: ", itemToDelete[index]);
                        }
                    }
                }
            }

            //ORDERING
            for (let index = 0; index < this.state.curItems.length; index++) {
                //console.log("ordering");
                const response = await _productCheckmanService.alertOrder(product.id, this.state.curItems[index].id, index);
            }

            this.setState({ savedBound: true });
        } catch (error) {
            console.warn("Erro on save: ", error);
            //NotificationComponent.Notify('error', 'Erro ao cadastrar', error);
        }
        // } finally {
        //     actions.setSubmitting(false);
        // }
    }

    endSave = async (product: ProductInterface) => {
        this.setState({ savingBound: false, savedBound: true });

        //this.loadProductAlerts(product); nao esta trazendo a lista marcada corretamente
        this.getProducts(true, true)
        this.setState({ alertsData: [], curProduct: undefined, curAlertsNotSelected: [], curAlertsSelected: [], savingBound: false, savedBound: false });
    }

    reorder = (list: any, startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,

        // change background colour if dragging
        background: isDragging ? 'lightblue' : 'white',

        // styles we need to apply on draggables
        ...draggableStyle,
    });

    getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? '' : '',
    });

    onDragEnd(result: any) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const newItems = this.reorder(
            this.state.curItems,
            result.source.index,
            result.destination.index
        );

        this.setState({
            curItems: newItems,
        });
    }

    render() {
        const {
            isLoading,
            isLoadingAlerts,
            showFormModal,
            productsData,
            curProduct,
            wantedProduct,
            alertsData,
            curAlertsSelected,
            showDraggableItems,
            curAlertsNotSelected,
            filteredTableData,
            editItem,
            serverResponse,
            search,
            changingProduct,
            savingBound,
            savedBound
        } = this.state;

        if (!!isLoading) {
            return (
                <AppContext.Consumer>
                    {({ locale, activeUnitId }) => (
                        this.setUnit(activeUnitId),
                        <span>{I18n.l('common.loadingTable')}</span>
                    )}
                </AppContext.Consumer>
            );
        }

        return (
            <Page>
                <AppContext.Consumer>
                    {({ locale, theme, activeUnitId }) => (
                        this.setUnit(activeUnitId),
                        <Row>
                            <Col sm={24} md={24} xl={24}>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        <h1>{locale &&
                                            `${I18n.l('titles.productsBoundsAlerts')}`}</h1>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        <Button type="primary" size="large" onClick={() => this.onSaveClicked(curAlertsSelected, curAlertsNotSelected, curProduct)} disabled={curProduct === undefined}>
                                            {locale &&
                                                `${I18n.l('common.save').toUpperCase()}`}
                                        </Button>
                                    </Col>
                                </Row>
                                <Row className="goepik-component-padding">
                                    <Col sm={24} md={8} xl={8}>
                                        <Row>
                                            <Col sm={24} md={24} xl={24}>
                                                <h2>{locale &&
                                                    `${I18n.l('titles.products')}`}</h2>
                                            </Col>
                                        </Row>
                                        <Row className="goepik-component-padding">
                                            <Col sm={24} md={24} xl={24}>
                                                {
                                                    (productsData != undefined) && productsData.map((item: ProductInterface, i: number) => {
                                                        return (
                                                            this.renderProductItem(item, i, curProduct)
                                                        )
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    {
                                        (isLoadingAlerts) && (
                                            <p>{I18n.l('common.loadingTable')}</p>
                                        )
                                    }
                                    {
                                        (alertsData != undefined && alertsData.length > 0 && !isLoadingAlerts) && (
                                            <Col sm={24} md={8} xl={8}>
                                                <Row>
                                                    <Col sm={24} md={24} xl={24}>
                                                        <h2>{I18n.l('titles.alerts')}</h2>
                                                    </Col>
                                                </Row>
                                                <Row className="goepik-component-padding">
                                                    <Col sm={24} md={24} xl={24}>
                                                        {
                                                            (alertsData.length > 0) && (
                                                                this.renderAlertList(alertsData, curProduct)
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        )
                                    }
                                    {
                                        (alertsData != undefined && alertsData.length > 0 && !isLoadingAlerts && this.state.curItems.length && showDraggableItems) && (
                                            <Col sm={24} md={8} xl={8}>
                                                <Row>
                                                    <Col sm={24} md={24} xl={24}>
                                                        <h2>{I18n.l('titles.productOrderTitle')}</h2>
                                                    </Col>
                                                </Row>
                                                <Row className="goepik-component-padding">
                                                    <Col sm={24} md={24} xl={24}>
                                                        <div>{I18n.l('titles.productOrderSub')}</div>
                                                    </Col>
                                                </Row>
                                                <Row className="goepik-component-padding">
                                                    <Col sm={24} md={24} xl={24}>
                                                        <DragDropContext onDragEnd={this.onDragEnd}>
                                                            <Droppable droppableId="droppable">
                                                                {(provided: any, snapshot: any) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        style={this.getListStyle(snapshot.isDraggingOver)}
                                                                    >
                                                                        {this.state.curItems.map((item: any, index: number) => (
                                                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                                                {(provided: any, snapshot: any) => (
                                                                                    <div
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}
                                                                                        style={this.getItemStyle(
                                                                                            snapshot.isDragging,
                                                                                            provided.draggableProps.style
                                                                                        )}
                                                                                    >
                                                                                        {index + 1}. {item.content}
                                                                                    </div>
                                                                                )}
                                                                            </Draggable>
                                                                        ))}
                                                                        {provided.placeholder}
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        </DragDropContext>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        )
                                    }
                                </Row>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        {changingProduct && (
                                            <Modal onClose={this.toggleFormModal} isOpen={showFormModal}>
                                                <ModalTitle>{I18n.l('titles.dataNotSaved')}</ModalTitle>
                                                <ModalContent>
                                                    <Row className="goepik-component-padding">
                                                        <Col sm={24} md={24} xl={24}>
                                                            <div>{I18n.l('titles.dataNotSavedText')}</div>
                                                        </Col>
                                                    </Row>
                                                    <Row className="goepik-component-padding" type="flex" justify="end">
                                                        <Col>
                                                            <Button type="default" size="large" onClick={this.cancelProductChange} disabled={curProduct === undefined}>
                                                                {locale &&
                                                                    `${I18n.l('common.cancel').toUpperCase()}`}
                                                            </Button>
                                                            <Button type="primary" size="large" onClick={() => this.confirmProductChange(wantedProduct)} disabled={curProduct === undefined}>
                                                                {locale &&
                                                                    `${I18n.l('common.exitNoSave').toUpperCase()}`}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </ModalContent>
                                            </Modal>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        {savingBound && (
                                            <Modal onClose={this.toggleFormModal} isOpen={showFormModal}>
                                                <ModalTitle>{I18n.l('labels.bound').toUpperCase()}</ModalTitle>
                                                <ModalContent>
                                                    {!savedBound && (
                                                        <Row>
                                                            <Col sm={24} md={24} xl={24}>
                                                                <p>{locale &&
                                                                    `${I18n.l('common.saving')}`}...
                                                            </p>
                                                            </Col>
                                                        </Row>
                                                    )
                                                    }
                                                    {savedBound && (
                                                        <Row>
                                                            <Col sm={24} md={24} xl={24}>
                                                                <p>{locale &&
                                                                    `${I18n.l('titles.boundSuccess')}`}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    )
                                                    }
                                                    <Row>
                                                        <Col sm={24} md={24} xl={24}>
                                                            <Button type="primary" size="large" onClick={() => this.endSave(curProduct)} disabled={!savedBound} loading={!savedBound}>
                                                                {locale &&
                                                                    `${I18n.l('common.ok').toUpperCase()}`}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    {serverResponse && (
                                                        <ApiResponseDisplayer theme={theme} locale={locale} data={serverResponse} />
                                                    )}
                                                </ModalContent>
                                            </Modal>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )}
                </AppContext.Consumer>
            </Page>
        );
    }
}

const GoEpikClickableItem = styled.div`
    .goepik-product-item:hover {
        background-color: ${Theme.standard.lightGray2 || '#f3f3f3'};
        cursor:pointer;
    }
    
    .goepik-product-active{
        h4{
            font-weight: 900;
        }
    }
`;

const GoEpikVerticalCheckbox = styled.div`
    .ant-checkbox-group-item {
        display: block!important;
    }
`;

const ModalTitle = styled.h3`
    font-size: 22px;
`;

const ModalContent = styled.div`
    width: 100%;
`;

export default Products;
